import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { RoleGuard } from '../../../../Components/Auth';
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs';
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader';
import UsersList from './UsersList';
import { Users, UserManagement as UserManagementTitle } from '../../../../utils/Constant';

const UserManagementContainer = () => {
  return (
    <RoleGuard allowedRoles="admin">
      <>
        <Breadcrumbs mainTitle={UserManagementTitle} parent={Users} />
        <Container fluid>
          <Row>
            <Col sm="12">
              <Card>
                <CommonCardHeader 
                  title={UserManagementTitle} 
                  span={[{ text: "Administración completa de usuarios del sistema. Solo visible para administradores." }]}
                />
                <CardBody>
                  <UsersList />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    </RoleGuard>
  );
};

export default UserManagementContainer;

